export const PAIEMENT_SOUSCRIPTION_PLATEFORME_PAIEMENT_FORM_NAME = "plateformePaiement";
export const PAIEMENT_SOUSCRIPTION_MODE_PAIEMENT_FORM_NAME = "modePaiement";
